import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Popconfirm } from 'antd';
import { Project } from '../../types/project';

interface EditProjectModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: { projectName: string; description: string }) => Promise<void>;
  onDelete: () => Promise<void>;
  loading: boolean;
  currentProject: Project | null;
}

const EditProjectModal: React.FC<EditProjectModalProps> = ({
  open,
  onCancel,
  onSubmit,
  onDelete,
  loading,
  currentProject
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && currentProject) {
      form.setFieldsValue({
        projectName: currentProject.projectName,
        description: currentProject.description
      });
    }
  }, [open, currentProject, form]);

  return (
    <Modal
      title="编辑项目"
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="projectName"
          label="项目名称"
          rules={[
            { required: true, message: '请输入项目名称' },
            { min: 2, message: '项目名称至少2个字符' },
            { max: 50, message: '项目名称最多50个字符' }
          ]}
        >
          <Input placeholder="给你的项目起个名字" />
        </Form.Item>
        <Form.Item
          name="description"
          label="项目描述"
          rules={[{ max: 500, message: '描述不能超过500个字符' }]}
        >
          <Input.TextArea 
            rows={4} 
            placeholder="可以描述你的想法、灵感或任何你想记录的信息。如果还没有具体想法也没关系，可以在后续使用 AI 助手帮你找到创业方向。" 
            maxLength={500}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            保存
          </Button>
        </Form.Item>
        <Popconfirm
          title="确定要删除这个项目吗？"
          description="删除后无法恢复，请谨慎操作。"
          onConfirm={onDelete}
          okText="确定"
          cancelText="取消"
        >
          <Button danger block>
            删除项目
          </Button>
        </Popconfirm>
      </Form>
    </Modal>
  );
};

export default EditProjectModal; 